import * as React from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme, Theme, createStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import MainMenu from './_navigation/Main';
import PermIdentity from '@material-ui/icons/PermIdentity';
import { BrowserRouter as Router } from 'react-router-dom';
import EWRouter from './_navigation/Router';
import { AuthContext } from './_auth/AuthContext';
import { INav, INavState } from './_types/nav';
import { NavigationContext } from './_navigation/NavigationContext';
import { GetMenu } from './_navigation/NavMenu';
import LocationSearch  from './common/LocationSearch';
import { GetMe } from './_service/auth';
import { IUser, IUserState } from './_types/user';
import { PolicyObjectTypeOptions } from './_types/ewpolicy';
import LinkBack from './engage/LinkBack';

const drawerWidth = 240;


interface Props {
  name?: string,
  classes?: any
};

const App: React.FC<Props> = (props: Props) => {



  //pull the requested path... once authenticated, will direct to that path
  const requested = window.location.pathname;

  //defines state for navigation context
  const [nav, setNav] = React.useState<INav>({open: false, openMenus: [], backLinks: []});
  let NavState: INavState = { nav, setNav };

  const [isenage, setEngage] = React.useState<boolean>(false);

  //defines state for Auth Context
  const [user, setUser] = React.useState<IUser>({fromCookie: true, objectType: PolicyObjectTypeOptions.user});
  const AuthState: IUserState = { user: user, setUser: setUser };

  const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    appBar: {
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    hide: {
      display: 'none',
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    userIcon: { marginLeft: "auto", marginRight: -12 },
    userName: { 
      [theme.breakpoints.down('xs')]: { display: 'none' },
    },
    drawerHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
      justifyContent: 'flex-end',
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: -drawerWidth,
    },
    contentShift: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }
  })
);

  const theme = useTheme();
  const classes = useStyles();
  

  //Attempt to init user from cookie
  React.useEffect(() => {
    
    //this is a poc hack ...
    if (requested.indexOf("engage") === -1) {
      setEngage(false);
    } else { setEngage(true);}
    
    GetMenu().map(grp => {
      nav.openMenus.push({ key: grp.key, open: false });
      return true;
    });

    GetMe().then((res) => {
      if (res) {
      
        if (res.authorized) {
          res.initialPath = requested;
          setNav({...nav, open: true });
        }
        setUser(res);
      }
    });
    
    
  }, []);

  
  const toggleDrawer = () => {
    let state = !nav.open;
    setNav({...nav, open: state});
  };

  if (!isenage) {
  return (
    <div className={classes.root}>
      <CssBaseline />
      <NavigationContext.Provider value={NavState}>
      <AuthContext.Provider value={AuthState}>
      <Router>
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: nav.open,
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={toggleDrawer}
            edge="start"
            className={clsx(classes.menuButton, nav.open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
          <LocationSearch small={true} onChange={() => {}} isUniversal />
          <span className={clsx(classes.userIcon, !user.authorized && classes.hide)}>
            
            <IconButton
              color="inherit"
              aria-label="User"
              edge="start"
              >
              
              <PermIdentity />
            </IconButton>
            <span className={classes.userName}>{user.displayName}</span>
          </span>
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="left"
        open={nav.open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton onClick={toggleDrawer}>
            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </div>
        <Divider />
        <MainMenu />


      </Drawer>
      
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: nav.open,
          })}
        >
        <div className={classes.drawerHeader} />
        <EWRouter/>
      </main>
      </Router>
      </AuthContext.Provider>
      </NavigationContext.Provider>
    </div>
  );
} else {
  return (<AuthContext.Provider value={AuthState}>
    <LinkBack link={requested}/>
  </AuthContext.Provider>)
}
}

export default App;